import type { SavedFixingOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedFixingOrder.ts';
import type { FixingOrder } from '@/store/orders/fixing/state.ts';

export const mapToFixing = (savedTile: SavedFixingOrder): FixingOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
